import React, { FC } from "react";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ArrowRight: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faArrowRight} {...props} />
);
